import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { RecordDetails } from "./routes";

export default (store, { isAccountLevel = false } = {}) => ({
  path: isAccountLevel
    ? "external-assessments/records/:schoolId"
    : "external-assessments/records",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "external-assessment-records" */ "./components"
      ),
    ]).then(([importedModule0]) => importedModule0.default)
  ),

  childRoutes: [RecordDetails(store)],
});
